import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Check if mobile

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        const toggleVisibility = () => {
            const scrollHeight = document.documentElement.scrollHeight;
            const scrollPosition = window.scrollY + window.innerHeight;

            // Show button when user has scrolled past 50% of the total page height
            if (scrollPosition > scrollHeight / 2) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Styling variables
    const buttonStyle = {
        position: "fixed",
        bottom: isMobile ? "10px" : "20px", // Closer to bottom
        right: "16px", // Closer to right
        backgroundColor: "#00C0E1", // Cyan color
        color: "#fff",
        padding: isMobile ? "10px" : "16px", // Smaller padding on mobile
        borderRadius: "50%",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        border: "none",
        cursor: "pointer",
        transition: "opacity 0.3s ease-in-out, transform 0.2s",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "scale(1)" : "scale(0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: isMobile ? "45px" : "50px", // Smaller size on mobile
        height: isMobile ? "45px" : "50px", // Smaller size on mobile
        zIndex: 1000, // Ensure above footer
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        // Fallback for custom scroll containers (e.g., if using a main div with overflow)
        const main = document.getElementById("root") || document.querySelector("main");
        if (main) {
            main.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <button onClick={scrollToTop} style={buttonStyle}>
            <ArrowUp size={isMobile ? 24 : 32} strokeWidth={3} />
        </button>
    );
};

export default ScrollToTop;
